(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-hero-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cc-video-hero]').forEach((hero) => {
    const video = hero.querySelector('video');
    if (!video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    video.addEventListener('canplay', () => hero.classList.add('is-video-ready'), { once: true });
    if (video.readyState >= 3) hero.classList.add('is-video-ready');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCarousel = (section) => {
      if (section.dataset.ccUgcReady === 'true') return;
      section.dataset.ccUgcReady = 'true';

      const track = section.querySelector('[data-cc-ugc-track]');
      const videos = Array.from(section.querySelectorAll('.cc-ugc__video'));
      const buttons = Array.from(section.querySelectorAll('[data-cc-ugc-play]'));
      const autoplayVideo = section.querySelector('[data-cc-ugc-autoplay]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let autoplayIsVisible = false;
      let autoplayWasActivated = false;

      const resetVideo = (video) => {
        video.pause();
        video.muted = true;
        video.controls = false;
        const button = video.closest('.cc-ugc__media')?.querySelector('[data-cc-ugc-play]');
        if (button) button.setAttribute('aria-pressed', 'false');
      };

      buttons.forEach((button) => {
        const video = button.closest('.cc-ugc__media')?.querySelector('.cc-ugc__video');
        if (!video) return;

        button.addEventListener('click', async () => {
          videos.filter((item) => item !== video).forEach(resetVideo);
          if (video === autoplayVideo) {
            autoplayWasActivated = true;
            video.loop = false;
          }
          video.muted = false;
          video.controls = true;
          try {
            await video.play();
            button.setAttribute('aria-pressed', 'true');
          } catch {
            video.controls = true;
          }
        });

        video.addEventListener('pause', () => {
          if (!video.ended) button.setAttribute('aria-pressed', 'false');
        });

        video.addEventListener('ended', () => {
          video.currentTime = 0;
          resetVideo(video);
        });
      });

      if (autoplayVideo && !reduceMotion) {
        const autoplayButton = autoplayVideo.closest('.cc-ugc__media')?.querySelector('[data-cc-ugc-play]');

        autoplayVideo.addEventListener('click', () => {
          if (autoplayVideo.paused || autoplayWasActivated) return;
          autoplayWasActivated = true;
          autoplayVideo.loop = false;
          autoplayVideo.muted = false;
          autoplayVideo.controls = true;
        });

        const autoplayObserver = new IntersectionObserver((entries) => {
          autoplayIsVisible = entries[0]?.isIntersecting && entries[0].intersectionRatio >= 0.6;

          if (!autoplayIsVisible || document.hidden) {
            autoplayVideo.pause();
            if (!autoplayWasActivated) autoplayButton?.setAttribute('aria-pressed', 'false');
            return;
          }

          if (autoplayWasActivated) return;
          autoplayVideo.muted = true;
          autoplayVideo.controls = false;
          autoplayVideo.loop = true;
          autoplayVideo.play()
            .then(() => autoplayButton?.setAttribute('aria-pressed', 'true'))
            .catch(() => autoplayButton?.setAttribute('aria-pressed', 'false'));
        }, { threshold: [0, 0.6] });

        autoplayObserver.observe(autoplayVideo);

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            autoplayVideo.pause();
          } else if (autoplayIsVisible && !autoplayWasActivated) {
            autoplayVideo.play().catch(() => autoplayButton?.setAttribute('aria-pressed', 'false'));
          }
        });
      }

      const scrollTrack = (direction) => {
        const card = track?.querySelector('.cc-ugc__card');
        if (!track || !card) return;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      };

      section.querySelector('[data-cc-ugc-prev]')?.addEventListener('click', () => scrollTrack(-1));
      section.querySelector('[data-cc-ugc-next]')?.addEventListener('click', () => scrollTrack(1));
    };

    document.querySelectorAll('[data-cc-ugc]').forEach(initializeCarousel);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches('[data-cc-ugc]') ? event.target : event.target.querySelector('[data-cc-ugc]');
      if (section) initializeCarousel(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
